module.exports = "<mat-chip-list #chipList aria-label=\"keyword selection\">\n  <mat-chip *ngFor=\"let word of searchKeyWordList;let i = index\" [selectable]=\"selectable\"\n      [removable]=\"removeChip\" (removed)=\"remove(word)\" class=\"mb-4\">\n      {{word|uppercase}}\n      <mat-icon matChipRemove *ngIf=\"removeChip\">cancel</mat-icon>\n  </mat-chip>\n</mat-chip-list>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/common/mat-chip-list/mat-chip-list.component.html
// module id = ../../../../../src/app/main/content/apps/common/mat-chip-list/mat-chip-list.component.html
// module chunks = main